import { ref } from "vue";

const applicationState = ref({});
const runningAsWechatMP = ref(false);

export { applicationState, runningAsWechatMP };
